module.exports = __webpack_public_path__ + "img/Logo_bianco_150.a80d0d4b.png";